// Points a "Manage Template" link at the template-management page for the
// currently-selected managing company in the upload form. Receives the
// route as a template URL containing the placeholder string emitted by
// TailoredProfiles::Cell::UploadForm — the controller doesn't need to
// know the URL's shape, only where the id slots in.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link"]
  static values = { urlTemplate: String, urlPlaceholder: String }

  connect() {
    this.updateFromSelect(this.element.querySelector("select"))
  }

  selectChanged(event) {
    this.updateFromSelect(event.target)
  }

  updateFromSelect(select) {
    const id = select?.value

    if (!id) {
      this.linkTarget.hidden = true
      return
    }

    this.linkTarget.hidden = false
    this.linkTarget.href = this.urlTemplateValue.replace(this.urlPlaceholderValue, id)
  }
}
